<template>
  <div class="d-inline">
    <v-tooltip
      v-if="disabled && disabledTooltip"
      bottom
    >
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
        >
          <v-icon
            :size="size"
            class="mx-2"
            name="delete"
            :title="disabledTooltip"
            disabled
          >
            mdi-delete
          </v-icon>
        </span>
      </template>
      <span>{{ disabledTooltip }}</span>
    </v-tooltip>
    <v-dialog
      v-else
      v-model="dialog"
      max-width="500px"
    >
      <template v-slot:activator="{ on }">
        <v-tooltip
          v-if="enabledTooltip"
          bottom
        >
          <template v-slot:activator="{ on: tooltipOn, attrs }">
            <span
              v-bind="attrs"
              v-on="tooltipOn"
            >
              <v-icon
                :size="size"
                class="mx-2"
                name="delete"
                :title="deleteTitle"
                :disabled="disabled"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </span>
          </template>
          <span>{{ enabledTooltip }}</span>
        </v-tooltip>
        <v-icon
          v-else
          :size="size"
          class="mx-2"
          name="delete"
          :title="deleteTitle"
          :disabled="disabled"
          v-on="on"
        >
          mdi-delete
        </v-icon>
      </template>
      <v-card
        title="Are you sure?"
        class="mb-0"
      >
        <v-card-title class="ma-2 text-center d-block">
          <span style="color: red">{{ $t('Delete.proceed') }}</span>
          <br>
          <span style="color: red">{{ $t('Delete.undone') }}</span>
        </v-card-title>
        <v-divider class="ma-2" />
        <v-card-actions class="ma-2 text-center">
          <v-spacer />
          <v-btn
            color="white"
            name="Cancel"
            class="text-right mr-10"
            @click="_onNo()"
          >
            NO
          </v-btn>
          <v-btn
            color="red"
            name="Add"
            class="text-right ml-10"
            @click="_onYes()"
          >
            {{ $t('Delete.agree') }}
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: null
    },
    size: {
      type: Number,
      default: 16
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledTooltip: {
      type: String,
      default: ''
    },
    enabledTooltip: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  computed: {
    deleteTitle() {
      return this.id ? `Delete ${this.id}` : 'Delete';
    }
  },
  created() {
    this.$emit('closeDialog');
  },
  methods: {
    _onYes() {
      this.$emit('deleted', this.id);
      this.dialog = false;
    },
    _onNo() {
      this.dialog = false;
    }
  }
};
</script>
